export default __webpack_public_path__ + "static/media/img_sneakpee01-m.b972ee89.png";